<div class="container">
  <div class="title">К сожалению, время вышло</div>
</div>
